import { useCallback } from "react";
import { CLEVERTAP_EVENTS} from "../../constant";
import { pushClevertapEvent } from "../analytics/clevertap";

export const handleClickCTEventSignUpSuccessExistingUser = () => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_SIGN_UP_SUCCESS, {
        "status": "Existing User"
    });
}

export const handleClickCTEventSuccess = () => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_ENTER_OTP, {
        "status": "New User event"
    });
}

export const handleClickCTEventExistingUser = () => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_ENTER_OTP, {
        "status": "Existing User trying on PWA"
    });
}

export const handleClickCTEventError = () => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_ENTER_OTP, {
        "status": "Wrong OTP Entered"
    });
}

export const handleClickCTEventSignUpSuccessNewUser = () => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_SIGN_UP_SUCCESS, {
        "status": "New User"
    });
}

export const handleClickCTEventExitTournament = () => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_EXIT_TOURNAMENT, {
        "status": "Exit Tournament"
    });
}

export const handleClickCTEventGameCompleted = () => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_GAME_COMPLETED, {
        "status": "Game Completed"
    });
}

export const handleClickCTEventWinnerScreen = () => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_WINNER_SCREEN, {
        "status": "Winner Screen"
    });
}

export const handleClickCTEventRegisterTournamentNonLoggedInUser = () => {
    pushClevertapEvent(CLEVERTAP_EVENTS.EVENT_PWA_REGISTER_TOURNAMENT_NON_LOGGED_IN_USER, {
        "status": "Register Tournament Non Logged In User"
    });
}
